export * from '@primeuix/themes/material/rating';
export { default } from '@primeuix/themes/material/rating';
